<template>
	<div class="address-page">

		<!-- 收货地址区块 -->
		<div class="member-card">
			<div class="card-header">
				<div>
					<div class="card-title">我的收货地址</div>
					<div class="card-desc">企业常用收货地址，下单时可快速选用</div>
				</div>
				<el-button type="primary" size="small" icon="el-icon-plus" @click="addInfo">添加新地址</el-button>
			</div>

			<!-- 地址卡片网格 -->
			<div v-loading="loading" element-loading-text="加载中...">
				<div class="addr-grid" v-if="list.length">
					<div
						class="addr-card"
						v-for="item in list"
						:key="item.id"
						:class="{ 'is-default': item.isDefault }"
					>
						<!-- 卡片顶部：收货人 + 默认标签 -->
						<div class="addr-card-top">
							<div class="addr-receiver">
								<!-- <i class="el-icon-user-solid addr-icon"></i> -->
								<span class="receiver-name">{{ item.receiverName }}</span>
							</div>
							<el-tag v-if="item.isDefault" size="mini" type="danger" effect="dark">默认</el-tag>
						</div>

						<!-- 手机号 -->
						<div class="addr-phone">
							<i class="el-icon-mobile-phone"></i>
							{{ item.receiverPhone }}
						</div>

						<!-- 地址 -->
						<div class="addr-detail">
							<i class="el-icon-location"></i>
							<span>{{ item.provinceName }}{{ item.cityName }}{{ item.districtName }} {{ item.detailAddress }}</span>
						</div>

						<!-- 操作按钮 -->
						<div class="addr-actions">
							<el-button type="text" size="small" @click="modifyInfo(item)">修改</el-button>
							<el-divider direction="vertical" />
<!--							v-if="!item.isDefault"-->
							<el-button  v-if="!item.isDefault" type="text" size="small" @click="setDefault(item)">设为默认</el-button>
							<el-divider v-if="!item.isDefault" direction="vertical" />
							<el-button type="text" size="small" style="color: #ef4444" @click="removeInfo(item.id)">删除</el-button>
						</div>
					</div>
				</div>

				<!-- 空状态 -->
				<div class="empty-state" v-else>
					<i class="el-icon-location-outline"></i>
					<p>暂无收货地址，点击「添加新地址」开始添加</p>
				</div>
			</div>
		</div>

		<!-- 新增/修改收货地址弹窗 -->
		<DialogAddress
			ref="DialogAddressRef"
			:dialogTitle="dialogTitle"
			:dialogVisible="dialogVisible"
			:form="form"
			:rules="rules"
			@addConfirmInfo="addConfirmInfo"
			@cancel="dialogVisible = false"
			@modifyConfirmInfo="modifyConfirmInfo"
		/>
	</div>
</template>

<script>
import Y from '@/utils/Y';
import DialogAddress from '@/views/UserCenter/components/DialogAddress.vue';
import {
	getCorporateGetAddress,
	deleteCorporateRemoveAddress,
	postCorporateUpdateAddress,
	postCorporateAddAddress,
	postCorporateSetDefaultAddress
} from '@/api/user/address';
import mtils from 'mtils';

export default {
	name: 'Address',
	components: { DialogAddress },
	data() {
		const validatePhone = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('收货人手机号码不可为空'));
			}
			if (!mtils.validation.isMobile(value)) {
				return callback(new Error('收货人手机号码格式不正确'));
			}
			callback();
		};
		return {
			list: [],
			loading: false,
			dialogTitle: '新增收货地址',
			dialogVisible: false,
			form: {
				receiverName: '',
				receiverPhone: '',
				provinceName: '',
				cityName: '',
				districtName: '',
				detailAddress: '',
				isDefault: 0
			},
			rules: {
				receiverName: [{ required: true, message: '收货人姓名不可为空', trigger: 'blur' }],
				receiverPhone: [{ required: true, validator: validatePhone, trigger: 'blur' }],
				detailAddress: [{ required: true, message: '详细地址不可为空', trigger: 'blur' }],
				provinceName: [{ required: true, message: '所属省不可为空', trigger: 'change' }],
				cityName: [{ required: true, message: '所属市不可为空', trigger: 'change' }],
				districtName: [{ required: true, message: '所属区不可为空', trigger: 'change' }]
			}
		};
	},
	created() {
		this.getCorporateGetAddress();
	},
	methods: {
		// 获取收货地址列表
		async getCorporateGetAddress() {
			this.loading = true;
			const res = await getCorporateGetAddress({});
			this.list = res.data.rows;
			this.loading = false;
		},

		// 添加收货地址
		addInfo() {
			this.form = {};
			this.dialogTitle = '新增收货地址';
			this.dialogVisible = true;
		},

		// 编辑收货地址
		modifyInfo(item) {
			this.form = {
				id: item.id,
				receiverName: item.receiverName,
				receiverPhone: item.receiverPhone,
				provinceName: item.provinceName,
				cityName: item.cityName,
				districtName: item.districtName,
				detailAddress: item.detailAddress,
				isDefault: item.isDefault ? 1 : 0
			};
			this.dialogTitle = '修改收货地址';
			this.dialogVisible = true;
		},

		// 确认添加收货地址
		addConfirmInfo(val) {
			if (this.list.length === 0) {
				val.isDefault = 1;
			} else {
				val.isDefault = 0;
			}
			postCorporateAddAddress(val)
				.then(() => {
					Y.msg.success('收货地址保存成功！');
					this.dialogVisible = false;
					this.getCorporateGetAddress();
				})
				.catch(err => {
					Y.msg.error(err.message);
				});
		},

		// 确认修改收货地址
		modifyConfirmInfo(val) {
			postCorporateUpdateAddress(val)
				.then(() => {
					Y.msg.success('收货地址修改成功！');
					this.dialogVisible = false;
					this.getCorporateGetAddress();
				})
				.catch(err => {
					Y.msg.error(err.message);
				});
		},

		// 删除收货地址
		removeInfo(id) {
			Y.confirm('确认删除此收货地址吗？').then(rlt => {
				if (rlt.confirm) {
					deleteCorporateRemoveAddress({removeIds: [id]})
						.then(() => {
							Y.msg.success('收货地址删除成功！');
							this.getCorporateGetAddress();
						})
						.catch(err => {
							Y.msg.error(err.message);
						});
				}
			});
		},

		// 设为默认
		setDefault(item) {
			Y.confirm('确认修改默认收货地址吗？').then(rlt => {
				if (rlt.confirm) {
					postCorporateSetDefaultAddress(item.id)
						.then(() => {
							Y.msg.success('默认收货地址修改成功！');
							this.getCorporateGetAddress();
						})
						.catch(err => {
							Y.msg.error(err.message);
						});
				}
			});
		}
	}
};
</script>

<style lang="less" scoped>
.address-page {
	padding: 0;
	margin-left: 20px;
}

/* ========== 卡片 ========== */
.member-card {
	background: #fff;
	border-radius: 12px;
	border: 1px solid #e2e8f0;
	padding: 24px 28px;
	margin-bottom: 16px;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

/* ========== 卡片头 ========== */
.card-header {
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	margin-bottom: 24px;
	padding-bottom: 20px;
	border-bottom: 1px dashed #e2e8f0;
}

.card-title {
	font-size: 16px;
	font-weight: 600;
	color: #0f172a;
	margin-bottom: 6px;
}

.card-desc {
	font-size: 13px;
	color: #94a3b8;
	line-height: 1.6;
}

/* ========== 地址卡片网格 ========== */
.addr-grid {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 16px;
}

/* ========== 单张地址卡片 ========== */
.addr-card {
	position: relative;
	border: 1px solid #e2e8f0;
	border-radius: 12px;
	padding: 18px 18px 14px;
	background: #fff;
	transition: border-color 0.2s, box-shadow 0.2s;

	&:hover {
		border-color: #bfdbfe;
		box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
	}

	&.is-default {
		// border-color: #ffc0c0;
		// background: #fffafa;
	}
}

/* ========== 卡片顶部 ========== */
.addr-card-top {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 12px;
	padding-bottom: 10px;
	// border-bottom: 1px dashed #e2e8f0;
}

.addr-receiver {
	display: flex;
	align-items: center;
	gap: 6px;
}

.addr-icon {
	font-size: 15px;
	color: #155dfc;
}

.receiver-name {
	font-size: 15px;
	font-weight: 600;
	color: #0f172a;
}

/* ========== 手机号 ========== */
.addr-phone {
	display: flex;
	align-items: center;
	gap: 6px;
	font-size: 13px;
	color: #475569;
	margin-bottom: 8px;

	i {
		color: #94a3b8;
		font-size: 14px;
	}
}

/* ========== 地址详情 ========== */
.addr-detail {
	display: flex;
	align-items: flex-start;
	gap: 6px;
	font-size: 13px;
	color: #334155;
	line-height: 1.6;
	min-height: 42px;

	i {
		color: #ef4444;
		font-size: 14px;
		margin-top: 2px;
		flex-shrink: 0;
	}

	span {
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
	}
}

/* ========== 操作按钮 ========== */
.addr-actions {
	display: flex;
	align-items: center;
	margin-top: 12px;
	padding-top: 10px;
	border-bottom: 1px solid #f1f5f9;
}

/* ========== 空状态 ========== */
.empty-state {
	padding: 48px 0;
	text-align: center;

	i {
		font-size: 40px;
		color: #dcdfe6;
	}

	p {
		margin-top: 12px;
		font-size: 13px;
		color: #c0c4cc;
	}
}
</style>
